import { createSelector } from '@ngrx/store';
import { ClosureState } from '../reducers/closures.reducers';
import { ClosuresDTO } from '../../commons/models/closures';
import { selectClosuresState, selectTenantState } from '../reducers';
import { TenantState } from '../reducers/tenant.reducers';

export const getClosuresTableState = createSelector(
    selectClosuresState,
  (state: ClosureState) => { return { total: state.total, currentPage: state.currentPage, perPage: state.perPage, order: state.order, direction: state.direction, filters: state.filters, includes: state.includes } }
);

export const getClosures = createSelector(
    selectClosuresState,
  (state: ClosureState) => state.list
);

export const getTotalClosures = createSelector(
    getClosuresTableState,
  (tableState) => tableState.total
);

export const getClosuresCurrentPage = createSelector(
    getClosuresTableState,
  (tableState) => tableState.currentPage
);

export const getClosuresPerPage = createSelector(
    getClosuresTableState,
  (tableState) => tableState.perPage
);

export const getClosuresDirection = createSelector(
    getClosuresTableState,
    (tableState) => tableState.direction
);

export const getFilters = createSelector(
    getClosuresTableState,
  (tableState) => tableState.filters
);

export const getClosureDialogId = createSelector(
    selectClosuresState,
  (state: ClosureState) => state.dialogId
);

export const getSelectionDialogId = createSelector(
    selectClosuresState,
  (state: ClosureState) => state.selectionDialogId
);

// export const selectSelectedTenantId = createSelector(
//     selectClosuresState,
//   (state: ClosureState) => {
//     console.log('Il selectedTenantId in closures è:', state.selectedTenantId); 
//     return state.selectedTenantId
//   }
// );

// export const selectTenantName = createSelector(
//   selectTenantState,
//   selectSelectedTenantId,
//   (tenantState: TenantState, selectedTenantId: number) => {
//     //console.log('TenantState:', tenantState);
//     const tenant = tenantState.list.find(t => t.id === selectedTenantId);
//     return tenant ? tenant.name : null;
//   }
// );

export const getSelectedClosuresCurrentPage = createSelector(
    selectClosuresState,
  (state: ClosureState) => {
    const selectedHours = (state.selectedClosures || []).map(bl => bl.id);
    return state.list?.filter(bl => selectedHours.includes(bl.id));
  }
);

